import React, { useEffect } from "react";
import styles from "./SyncButton.module.css";
import Group from "../../assets/icons/successCheck.svg";

const SyncPopup = ({ onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 1000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={styles.overlay}>
      <div className={styles.popupContainer}>
        <div className={styles.iconWrapper}>
          <img src={Group} alt="Success" className={styles.icon} />
        </div>
        <p className={styles.message}>Push Initiated Successfully</p>
      </div>
    </div>
  );
};

export default SyncPopup;
